'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:NeworderCtrl
 * @description
 * # NeworderCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('NeworderCtrl', function($routeParams, $location, cfpLoadingBar, moment,
    FlashService, orderService, lookupService) {
    var newOrderVm = this;

    newOrderVm.homeId = $routeParams.homeId;
    newOrderVm.orderId = $routeParams.orderId;
    newOrderVm.isExistingOrder = !!newOrderVm.orderId;
    newOrderVm.customerId = $location.search().customerId;
    newOrderVm.submit = submit;
    newOrderVm.isMaintenance = isMaintenance;
    newOrderVm.isLawncare = isLawncare;
    newOrderVm.bundles = [];
    newOrderVm.bundleCategories = [{
        name: 'Maintenance'
      },
      {
        name: 'Lawncare'
      }
    ];
    newOrderVm.orderData = {
      startDate: '',
      endDate: '',
      tillFurtherNotice: true,
      bundleId: '',
      bundle: {},
      homeId: newOrderVm.homeId,
      grassCuttingHeight: null,
      hoursPerVisit: null,
      servicePrices: []
    };

    activate();

    return newOrderVm;

    function activate() {
      if (newOrderVm.isExistingOrder) {
        getOrder(newOrderVm.orderId)
          .then(getOrderSuccess);
      }
    }

    function getOrder(id) {
      newOrderVm.inprogress = true;
      cfpLoadingBar.start();
      return orderService.getById(id)
        .then(function(response) {
          newOrderVm.orderData = response;
        })
        .finally(function() {
          newOrderVm.inprogress = false;
          cfpLoadingBar.complete();
        });
    }

    function getOrderSuccess() {
      newOrderVm.orderData.bundleCategory = newOrderVm.orderData.bundle.bundleCategory;
      newOrderVm.orderData.startDate = moment(newOrderVm.orderData.startDate, moment.ISO_8601).format('DD/MM/YYYY');
      newOrderVm.orderData.endDate = moment(newOrderVm.orderData.endDate, moment.ISO_8601).format('DD/MM/YYYY');
      newOrderVm.orderData.endDate = newOrderVm.orderData.tillFurtherNotice ? '' : newOrderVm.orderData.endDate;
      newOrderVm.disableStartDate = moment(newOrderVm.orderData.startDate, 'DD/MM/YYYY').isSame(moment()) ||
                      moment(newOrderVm.orderData.startDate, 'DD/MM/YYYY').isBefore(moment());
    }

    function submit(valid) {
      if (valid) {
        newOrderVm.inprogress = true;
        cfpLoadingBar.start();

        if (isMaintenance()) {
          submitMaintenance();
        } else {
          submitCustom();
        }
      }
    }

    function submitCustom() {
      orderService.create(newOrderVm.orderData)
        .then(function(response) {
          FlashService.Success('Order created');
          redirectToPath();
        })
        .catch(function(error) {
          FlashService.Error(error.message);
        })
        .finally(function() {
          newOrderVm.inprogress = false;
          cfpLoadingBar.complete();
        });
    }

    function submitMaintenance() {
      var submitMaintenanceOrder = newOrderVm.isExistingOrder ?
            updateMaintenance : createMaintenance;

      submitMaintenanceOrder()
        .finally(function() {
          newOrderVm.inprogress = false;
          cfpLoadingBar.complete();
        });
    }

    function createMaintenance() {
      return orderService.createMaintenance(newOrderVm.orderData)
        .then(function(response) {
          FlashService.Success('Maintenance Order created');
          redirectToPath();
        })
        .catch(function(error) {
          FlashService.Error(error.message);
        });
    }

    function updateMaintenance() {
      return orderService.updateMaintenance(newOrderVm.orderData)
        .then(function(response) {
          FlashService.Success('Maintenance Order created');
          redirectToPath();
        })
        .catch(function(error) {
          FlashService.Error(error.message);
        });
    }

    function redirectToPath() {
      if (!!newOrderVm.orderData.customerId) {
        var customerOrderUrl = '/customers/' + newOrderVm.orderData.customerId + '/orders';
        $location.path(customerOrderUrl).search('homeId', newOrderVm.orderData.homeId);
      } else if (!!newOrderVm.customerId){
        $location.path(`/customers/${newOrderVm.customerId}/orders`);
      } else {
        $location.path('/customers');
      }
    }

    function isMaintenance() {
      return newOrderVm.orderData.bundleCategory === 'Maintenance';
    }

    function isLawncare() {
      return newOrderVm.orderData.bundleCategory === 'Lawncare';
    }
  });
